import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Page} from '../models/page';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

const apiUrl = '/api/v1/dashboardQuery';

@Injectable()
export class DashboardQueryService {

  constructor(private http: HttpClient) { }

    runQuery(key: string, parameters: any) {
    const url = `${apiUrl}/data/${key}` ;
    return this.http.post<any>(url, parameters,{});
  }

  /**
   * V2 dashboard: server-side aggregated pivot of qualification counts.
   * request = { dateDebut, dateFin, equipeIds?, userIds?, groupBy: 'COMMERCIAL' | 'EQUIPE' }
   */
  qualificationsPivotV2(request: any): Observable<any> {
    const url = `${apiUrl}/v2/qualifications-pivot`;
    return this.http.post<any>(url, request, httpOptions);
  }

  /**
   * V2 dashboard: page de fiches commerciales derriere un chiffre du pivot.
   * request = filtres du pivot + { dimId, step, status, page, size }
   */
  qualificationsDetailV2(request: any): Observable<any> {
    const url = `${apiUrl}/v2/qualifications-detail`;
    return this.http.post<any>(url, request, httpOptions);
  }

  findByPageAndType(queryCategoryName: string, p: number, size: number): Observable<any> {
    const params = new HttpParams()
      .set('category', String(queryCategoryName)) .set('page', String(p)).set('pageSize', String(size));
    return this.http.get<Page>(apiUrl, {params});
  }

  findByPage(p: number, size: number): Observable<any> {
    const params = new HttpParams()
      .set('page', String(p)).set('pageSize', String(size));
    return this.http.get<Page>(apiUrl, {params});
  }

  findAll(): Observable<any> {
    const url = `${apiUrl}/all`;
    return this.http.get<any>(url);
  }

  getById(id: number) {
    const url = `${apiUrl}/${id}`;
    return this.http.get<any>(url);
  }

  create(dashboardQuery: any) {
    return this.http.post<any>(apiUrl, dashboardQuery, httpOptions);
  }

  update(id: number, dashboardQuery: any) {
    const url = `${apiUrl}/${id}`;
    return this.http.put(url, dashboardQuery, httpOptions);
  }

  delete(id: number) {
    const url = `${apiUrl}/${id}`;
    return this.http.delete<any>(url, httpOptions);
  }

}
